import styled from 'styled-components'

export const Page = styled.div<{ noMaxHeight?: boolean }>`
  padding: 20px 80px;
  background-color: #f5f5f5;
  flex: 1;
  display: flex;
  flex-direction: column;
  ${({ noMaxHeight }) =>
    !noMaxHeight && 'max(1000px, calc(100vh - 70px - 70px));'}

  @media (max-width: 1024px) {
    padding: 0;
  }
`

export const Container = styled.div`
  background-color: #fff;
  border-radius: 8px;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  box-shadow:
    0px 4px 8px -2px rgba(16, 24, 40, 0.1),
    0px 2px 4px -2px rgba(16, 24, 40, 0.06);
  overflow: hidden;
`
